import { createContext } from 'react';

const defaultData: AssetAccountContextType = {
  urls: {},
  hasMultipleAccounts: false,
  userFullName: '',
  handleChangeAccount: () => true,
  retailEnabled: false
};

export default createContext(defaultData);
